import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./toastClearAll.scss";

// Mount once (src/index.js): react-toastify 5 has no way to remove an
// onChange listener, so a remounting component would stack them up.
const ToastClearAll = () => {
  const [count, setCount] = useState(0);
  const visible = count >= 2;

  useEffect(() => {
    toast.onChange(setCount);
  }, []);

  // Pushes the toast stack down to make room for the button.
  useEffect(() => {
    document.body.classList.toggle("toast-clear-all-visible", visible);
    return () => document.body.classList.remove("toast-clear-all-visible");
  }, [visible]);

  if (!visible) return null;

  const clearAll = () => {
    toast.dismiss();
    // dismiss() with no id does not fire onChange, so reset the count here.
    setCount(0);
  };

  return (
    <button type="button" className="toast-clear-all" onClick={clearAll}>
      Clear all
    </button>
  );
};

export default ToastClearAll;
